import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  range,
} from 'lodash';
import { ScrollFade } from 'shared/components';

import SeatingChartUserIcon from 'assets/svgs/seatingChartUser.svg';
import './GridView.scss';

const GridView = (props) => {
  const { t } = useTranslation();
  const {
    rows,
    cols,
    seatsData,
    windowSize,
    setLastFetchTime,
    setIsUpdateStatus,
    isAutoRefreshStarted,
    isUpdateStatus
  } = props;

  const [computedHeight, setComputedHeght] = useState(350);
  const [scrollPosition, setScrollPosition] = useState(0);
  const scrollContainer = useRef();
  const [scrollHeight, setScrollHeight] = useState(0);

  useEffect(() => {
    const gridElement = document.getElementById('grid-view');
    const height = window.innerHeight
      || document.documentElement.clientHeight
      || document.body.clientHeight;
    let computedHeight = height - 100 - gridElement.getBoundingClientRect().top;
    computedHeight = computedHeight < 350 ? 350 : computedHeight;
    setComputedHeght(computedHeight);
  }, []);
  const CellComponent = props.cellComponent;
  // const isMacOs = navigator.appVersion.indexOf("Mac") !== -1;
  const handleVerticalScroll = (e) => {
    const pageScrollPosition = window.pageYOffset;
    const {current} = scrollContainer;
    setScrollHeight(document.body.scrollHeight - pageScrollPosition - window.innerHeight-55);
    setScrollPosition(pageScrollPosition - (current.offsetTop+65))
  };
  useEffect(() => {
    window.addEventListener('scroll', handleVerticalScroll);
    return () => {
      window.removeEventListener('scroll', handleVerticalScroll);
    };
  }, []);
  const footerStyle = scrollPosition >=0 ? { position: 'sticky', bottom: scrollHeight -25} : {}

  return (
    <div className="grid-view" id="grid-view"
         style={{height: windowSize > 1199 ? computedHeight + 'px' : 'auto'}} >
      {/*<Scrollbars*/}
      {/*  autoHeight*/}
      {/*  autoHeightMin={100}*/}
      {/*  autoHeightMax={computedHeight}*/}
      {/*  className={`grid-view-scroll ${!isMacOs ? 'scroll-mac-os' : ''}`}*/}
      {/*>*/}
        <div className={`grid-content-scroll`} ref={scrollContainer}>
          <ScrollFade>
          <div className="grid-content">
            <div className="header-content" style={{top: windowSize > 1199 ? 0 : scrollPosition}}>
              <div className="grid-row header-row">
                {/*<div className="cell-letter">&nbsp;</div>*/}
                {range(0, cols)
                  .map(i =>
                    <div className="cell" key={`footer-${i}`}>
                      <SeatingChartUserIcon />
                      {i + 1} ({t('seatingChart.backLabel')})
                    </div>
                  )}
              </div>
            </div>
            <div className="left-header">
              {range(0, rows)
                .map(i =>
                    <div className="cell-letter" key={`cell-${i}`}>{String.fromCharCode('A'.charCodeAt(0) + i)}</div>
                )
              }
            </div>
            <div className="d-flex flex-column-reverse">
              {range(0, rows)
                .map(i =>
                  <div className="grid-row" key={`row-${i}`}>
                    {/*<div className="cell-letter">{String.fromCharCode('A'.charCodeAt(0) + i)}</div>*/}
                    {range(0, cols)
                      .map(j =>
                        <CellComponent
                          cellData={seatsData[i] ? seatsData[i][j] : null}
                          key={`cell-comp-${j}`}
                          setLastFetchTime={setLastFetchTime}
                          setIsUpdateStatus={setIsUpdateStatus}
                          isAutoRefreshStarted={isAutoRefreshStarted}
                          isUpdateStatus={isUpdateStatus}
                        />
                      )}
                    <div className="empty-cell"></div>
                  </div>
                )}
            </div>

            <div className="footer-content" style={windowSize > 1199 ? {} : footerStyle}>
              <div className="grid-row footer-row">
                {/*<div className="cell-letter"></div>*/}
                {range(0, cols)
                  .map(i =>
                    <div className="cell" key={`header-${i}`}>
                      {`${i + 1} (${t('seatingChart.frontLabel')})`}
                    </div>
                  )}
              </div>
            </div>
          </div>
          </ScrollFade>
        </div>
      {/*</Scrollbars>*/}
    </div>
  );
}

GridView.defaultProps = {
  smallRefFlag: false,
};

GridView.propTypes = {
  cols: PropTypes.number.isRequired,
  rows: PropTypes.number.isRequired,
  smallRefFlag: PropTypes.bool,
};

export default GridView;
